import styled from '@emotion/styled';

export const ForecastWrapper = styled.div``;
